export class FinallUserResendInvitationsModel {
    email!: string;
    inviteHash!: string;
    language: string;
}